import axios from "axios";

const axiosInstance = axios.create({
   //https://asap-backend-1.onrender.com
  baseURL:  "https://asap-backend-1.onrender.com" ,   // https://seal-app-ivge2.ondigitalocean.app // http://localhost:5000    "https://starfish-app-njk48.ondigitalocean.app"
});  //http://localhost:5000   https://asap-backend-5v3x.onrender.com

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ✅ Auth routes
export const login = async (formdata) => 
  axiosInstance.post("/api/auth/login", formdata);
export const signup = async (formdata) =>
  axiosInstance.post("/api/auth/signup", formdata);

export const generateResetCode = async (email) =>
  axiosInstance.post("/api/auth/generate-reset", { email });

// ✅ Password Reset Routes
export const addReview = async (review) =>
  axiosInstance.post("/api/review", review);

export const getShopReviews = async (sellerId, page, limit = 20) =>
  axiosInstance.get(`/api/review/shop/${sellerId}?page=${page}&limit=${limit}`);

export const GetAnyOrders = (id, role, page, limit) =>
  axiosInstance.get(`/order/any/${id}/${role}?page=${page}&limit=${limit}`);



export const Getorders = async (id, page, limit = 20) =>
  axiosInstance.get(`/order/${id}?page=${page}&limit=${limit}`);

export const deleteAccount = (userId) => axiosInstance.delete(`/api/delete-account/${userId}`);

// Add viewerId as an optional query parameter
export const Viewshop = async (id, currentPage, limit = 20, viewerId = null) => {
  let url = `/api/shop/${id}?page=${currentPage}&limit=${limit}`;
  if (viewerId) url += `&viewerId=${viewerId}`;
  return axiosInstance.get(url);
};




export const gettrackOrderById = async (id) =>            // No backend 
  axiosInstance.get(`/order/track-stage/${id}`);   



export const Gettrackorders = async (userId, page = 1, limit = 20) =>
  axiosInstance.get(`/order/track/${userId}?page=${page}&limit=${limit}`);


export const getAdminOrder = async  (page, limit, status) =>
  axiosInstance.get(`/api/admin/orders?page=${page}&limit=${limit}${status ? `&status=${status}` : ""}`);
export const getAllUsers = async ( page , limit = 20) =>
  axiosInstance.get(`/api/admin?page=${page}&limit=${limit}`);  

export const getAllUsersrider = async ( page , limit = 20) =>
  axiosInstance.get(`/api/admin/riders?page=${page}&limit=${limit}`);

export const getAdminPayments = async (page, limit, type, status ) =>
  axiosInstance.get(`/api/admin/payment?page=${page}&limit=${limit}&type=${type}&status=${status}`);

export const postDevice = async (deviceId) =>
  axiosInstance.post(`/api/admin/device`, { deviceId });

// Track clicks
export const postClick = async (type, deviceId) =>
  axiosInstance.post(`/api/admin/click`, { type, deviceId });

export const Getsellerorders = async (id, page, limit = 20) =>
  axiosInstance.get(`/order/seller/${id}?page=${page}&limit=${limit}`);

export const countunreadMessages = (userId) =>
  axiosInstance.get(`/api/message/${userId}/unread`);


export const getConversationMessages = (conversationId, userId ,  page , limit = 30) =>
  axiosInstance.get(`/api/message/${conversationId}/${userId}/messages?page=${page}&limit=${limit}`);

export const postConversationMessage = (conversationId, payload) =>
  axiosInstance.post(`/api/message/${conversationId}/messages`, payload);

export const markConversationRead = (conversationId ,userId) =>
  axiosInstance.post(`/api/message/${conversationId}/${userId}/read`, { });


export const Getriderorders = async (id, page , limit = 20) =>
  axiosInstance.get(`/order/rider/${id}?page=${page}&limit=${limit}`);

export const  createConversation = async (data) =>
  axiosInstance.post("/api/conversation", data);

export const getConversations = async (userId, page = 1, limit = 20) =>
  axiosInstance.get(`/api/conversation/${userId}?page=${page}&limit=${limit}`);

// api/index.js
export const getConversationsadmin = async (page , limit = 10) =>
  axiosInstance.get(`/api/admin/getconversation`, {
    params: { page, limit },
  });

  
// api/index.js
export const getEmails = async () =>
  axiosInstance.get(`/api/admin/special`);


export const SelectitemandgetUsers = async (userId, subCategory) =>
  axiosInstance.get(`/api/select/${userId}/${subCategory}`);

export const searchUser = async (body) => {
  return axiosInstance.post("/api/searchUser",body);
};



export const aiSearch = async (body) => {
  return axiosInstance.post("/api/ai-search", body);
};


// api/index.js
export const fetchAIProductSearch = async (body) => {
  return axiosInstance.post("/api/ai-search/ai-product-search", body);
};




export const Blockproductpost = async (data) => 
  axiosInstance.post("/api/products/block-product", data);


  
export const unblockProduct = async (data) => 
  axiosInstance.post("/api/products/unblock-product", data);


export const getBlockedProducts = async (userId) => 
  axiosInstance.get(`/api/products/get-blocked/${userId}`);

// Get list of blocked shops
export const getBlockedUsers = (userId) => 
  axiosInstance.get(`/api/get-blocked-users/${userId}`);

export const toggleBlockSeller = async (data) => 
  axiosInstance.post("/api/block-seller", data);
// Unblock a shop
export const unblockUser = (data) => 
  axiosInstance.post("/api/unblock-user", data);
export const fetchProductData = async (params) => {
  return axiosInstance.get("/api/getlistriders", { params });
};



export const getRidersByLocation = async (lga) =>
  axiosInstance.get(`/api/getlistriders/${lga}`);

export const verifyResetCode = async (formData) =>
  axiosInstance.post("/api/auth/verify-reset", formData);

export const uploadProduct = async (formData, config = {}) =>
  axiosInstance.post("/api/products/upload", formData, config);

export const postfeedback = async (form) =>
  axiosInstance.post("/api/feedback", form);

export const getContractByUniqueId = async (uniqueId) =>
  axiosInstance.get(`/api/contracts/${uniqueId}`);

export const acceptContract = async (contractId) =>
  axiosInstance.put(`/api/contracts/${contractId}/seller/accept`);

export const rejectContract = async (contractId) =>
  axiosInstance.put(`/api/contracts/${contractId}/seller/reject`);

export const cancelContract = async (contractId) =>
  axiosInstance.put(`/api/contracts/${contractId}/seller/cancel`);

export const submitDeliveryContract = async (contractId, message = "") =>
  axiosInstance.put(`/api/contracts/${contractId}/seller/submit`, {
    message,
  });

export const completeContract = async (contractId) =>
  axiosInstance.put(`/api/contracts/${contractId}/buyer/complete`);

export const requestContractRevision = async (contractId, message) =>
  axiosInstance.put(`/api/contracts/${contractId}/buyer/revision`, {
    message,
  });

export const initializeContractPayment = async (formData) =>
  axiosInstance.post(
    "/api/contracts/paystack/initialize-contract",
    formData
  );

  export const fetchContractById = async (id) => {
  const response = await axiosInstance.get(`/api/contracts/lookup/${id}`);
  return response.data;
};
export const xaraFundWallet = async (data) => await axiosInstance.post("/api/xara/fund-wallet", data);

export const submitPayoutDetails = async (contractId, payoutData) =>
  axiosInstance.post(`/api/contracts/${contractId}/payout`, payoutData);
export const koraPayapi = async (formData) =>
  axiosInstance.post("/api/paystack/initialize", formData);


export const searchUserByProfile = async (profile, viewerId) =>
  axiosInstance.get(
    `/api/connectuser/users/search-profile?profile=${encodeURIComponent(profile)}&viewerId=${encodeURIComponent(viewerId || "")}`
  );


  


export const searchProductByName = async (product, userId) =>
  axiosInstance.get(
    `/api/connectuser/products/search-product?product=${encodeURIComponent(
      product
    )}&userId=${encodeURIComponent(userId || "")}`
  );






export const XaraPayment = async (formData) =>
  axiosInstance.post("/api/xara/initialize", formData);

export const Createorder = async (order) =>
  axiosInstance.post("/order/create-order",  order );

export const Createorderbalance = async (payload) =>
  axiosInstance.post("/order/create-order-balance",  payload );

// export const shopView = async (id) => axiosInstance.get(`/api/shop/${id}`);  

export const resetPassword = async (payload) =>
  axiosInstance.post("/api/auth/reset-password", payload);

export const markNotificationRead = async (notificationId) =>
  axiosInstance.put(`/api/notification/read/${notificationId}`);

export const getNotifications = async (userId, page = 1, limit = 20) =>
  axiosInstance.get(`/api/notification/${userId}?page=${page}&limit=${limit}`);

export const getUserProfile = async (userId) =>
  axiosInstance.get(`/api/getuserprofile/${userId}`);               // NO Frontend

export const toggleBookmarkUser = (data) => 
  axiosInstance.post("/api/bookmark-user", data);

// Updated to match the pattern used in Viewshop
export const Viewproduct = async (id, viewerId = null) => {
  let url = `/api/viewproduct/${id}`;
  if (viewerId) url += `?viewerId=${viewerId}`;
  return axiosInstance.get(url);
};


// Toggle product bookmark
export const toggleBookmarkProduct = (data) =>
  axiosInstance.post("/api/bookmark-product", data);


export const getBookmarkedUsers = ({ userId, page = 1, limit = 20 }) =>
  axiosInstance.get(`/api/bookmarked-users/${userId}?page=${page}&limit=${limit}`);

export const getBookmarkedProducts = ({ userId, page = 1, limit = 20 }) =>
  axiosInstance.get(`/api/bookmarked-products/${userId}?page=${page}&limit=${limit}`);

export const getSingleProduct = async (productId) =>
  axiosInstance.get(`/api/getproducts/${productId}`);


export const updateProduct = async (productId, formData, config = {}) =>
  axiosInstance.put(`/api/updateproduct/${productId}`, formData, config);


export const UserProfile = async (userId) =>
  axiosInstance.get(`/api/userprofile/${userId}`);  


export const fetchUserProducts = async (email, page = 1) =>
  axiosInstance.get(`/api/getproduct/${email}?page=${page}`);

export const deleteProduct = async (productId) => 
   axiosInstance.delete(`/api/deleteproduct/${productId}`); // adjust endpoint



export const getUserBalance = async (id) =>  
  axiosInstance.get(`/api/payments/balance/${id}`);

export const getUserAccounts = async (userId) => 
  axiosInstance.get(`/api/payments/getUserAccountDetails/${userId}`);


export const getUserPayments = async (id) =>
  axiosInstance.get(`/api/payments/user/${id}`);

export const fundwallet = async (userId, amount) =>
  axiosInstance.post(`/api/payments/fundwallet`, { userId, amount });
    
/// Contiue here     
    
export const addAccount = async (
payload
) =>
  axiosInstance.post(`/api/payments/account/add`, 
   payload
  );  
      
    
export const withdrawal = async (
  payload
) => 
  axiosInstance.post(`/api/payments/withdraw`, payload);




export const CompleteProfileseller = async (formData) =>
  axiosInstance.post("/api/complete-profile-seller", formData ,  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });



  export const CompleteRiderProfile = async (formData) =>
  axiosInstance.post("/api/complete-rider", formData ,  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

 export const addShopImage = async (formData) =>
  axiosInstance.post("/api/add-shop-image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  export const GetHomepageSellers = (page = 1) =>
  axiosInstance.get(`/api/homepage-sellers?page=${page}`);

export const CompleteProfile = async (payload) =>
  axiosInstance.post("/api/update-profile", payload );

export const resetPasswordinProfile = async (resetpassword) =>
  axiosInstance.post("/api/reset-password-profile", resetpassword);

export const VerifyOTP = async (payload) =>
  axiosInstance.post("/api/verify-otp", payload);

export const  postAdminNotification = async (data) =>
  axiosInstance.post("/api/notification", data);





export const updateOrderStage = async (orderId, stage) =>
  axiosInstance.patch(`/order/${orderId}/tracking`, { stage });

export const acceptOrders = async (id) =>
  axiosInstance.patch(`/api/admin/orders/${id}/accept`);

export const acceptWithdraw = async (id) =>
  axiosInstance.patch(`/api/admin/transactions/${id}/success`);


export const acceptPayment = async (id) =>
  axiosInstance.patch(`/api/admin/accept/${id}`);


export const confirmDelivery = async (orderId) =>  
  axiosInstance.put(`/order/${orderId}/confirm-delivery`);

                                                  

export const deleteShopImage = async (userId, imageUrl) =>
  axiosInstance.delete(`/api/delete/${userId}/shop-image` ,  {
      data: { imageUrl }, // must wrap it inside `data`
    });

export const SendOTP = async (email) => 
  axiosInstance.post("/api/send-otp", {email});

export const updateLevel = async (userId) =>         // No Frontend 
  axiosInstance.put(`/order/${userId}/level`); 



export const editProfile = async (formData) => {
  const data = new FormData();

  data.append("id", formData.id);
  data.append("name", formData.Name);
  data.append("email", formData.Email);
  data.append("phone", formData.phone);
  data.append("lga", formData.lga);
  data.append("address", formData.address);

  if (formData.bio) data.append("bio", formData.bio);

  // ✅ FIX: Store only the "item" field (not category/sub)
  if (formData.fields && Array.isArray(formData.fields)) {
  
    formData.fields.forEach((field, index) => {
      if (typeof field === "object") {
        const text = field.item || ""; // 👈 only keep item
        data.append(`fields[${index}]`, text.trim());
      } else {
        data.append(`fields[${index}]`, field);
      }
    });
  }

  if (formData.profileImage) {
    data.append("profileImage", formData.profileImage);
  }

  return await axiosInstance.post(`/api/edit-profile/${formData.id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateUserPushToken = async (userId, expoPushToken) => {
  return axiosInstance.patch(`/api/storeuser/updatePushToken`, {
    userId,
    expoPushToken,
  });
};